<nz-spin
  nzSimple
  [nzIndicator]="indicatorTemplate"
  [nzSpinning]="loading"
  [ngStyle]="{ textAlign: 'center' }"
>
  <ng-content></ng-content>
</nz-spin>
<ng-template #indicatorTemplate>
  <span
    class="loading-spin-icon"
    nz-icon
    [nzType]="icon"
    [ngStyle]="{ fontSize: size }"
  ></span>
  @if (text) {
  <span class="loading-spin-text">{{ text }}</span>
  }
</ng-template>
